module.exports = __webpack_public_path__ + "static/media/04_red_ball.c52ec564.gif";